// Toolbar.js
import React from "react";
import {
  Button,
  Divider,
  makeStyles,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  tokens,
} from "@fluentui/react-components";
import {
  WeatherSunnyFilled,
  WeatherMoonFilled,
  SignOutRegular,
  MoreVerticalFilled,
  ToggleRightFilled,
  ToggleLeftFilled,
  Settings28Filled,
} from "@fluentui/react-icons";
import { useStateStore } from "../../store";
import { t } from "../../utils/translations";

const useStyles = makeStyles({
  toolbar: {
    position: "fixed",
    bottom: "10px",
    right: "10px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    backgroundColor: tokens.colorNeutralBackground3,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    boxShadow: tokens.shadow4,
  },
});

const Toolbar = () => {
  const { isDarkMode, setIsDarkMode, logout, status, addinEnabled, setAddinEnabled } = useStateStore();
  const styles = useStyles();

  const onToggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const toggleAddin = () => {
    setAddinEnabled(!addinEnabled);
  };

  return (
    <div className={styles.toolbar}>
      <Menu>
        <MenuTrigger>
          <MenuButton icon={<Settings28Filled />} title={t("moreOptions")} />
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            {isDarkMode && (
              <MenuItem onClick={onToggleTheme} icon={<WeatherSunnyFilled />}>
                {t("lightMode")}
              </MenuItem>
            )}
            {!isDarkMode && (
              <MenuItem onClick={onToggleTheme} icon={<WeatherMoonFilled />}>
                {t("darkMode")}
              </MenuItem>
            )}
            {status === "success" && (
              <MenuItem onClick={logout} icon={<SignOutRegular />}>
                {t("logout")}
              </MenuItem>
            )}
            <Divider />
            {addinEnabled && (
              <MenuItem icon={<ToggleLeftFilled />} onClick={toggleAddin}>
                {t("disableAddin")}
              </MenuItem>
            )}
            {!addinEnabled && (
              <MenuItem icon={<ToggleRightFilled />} onClick={toggleAddin}>
                {t("enableAddin")}
              </MenuItem>
            )}
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
};

export default Toolbar;
